import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  type SignInPageProps,
} from '@backstage/plugin-app-react';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import {
  SignInPage,
  type SignInProviderConfig,
} from '@backstage/core-components';

const githubProvider: SignInProviderConfig = {
  id: 'github-auth-provider',
  title: 'GitHub',
  message: 'Sign in using GitHub',
  apiRef: githubAuthApiRef,
};

/**
 * GitHub sign-in in production; guest additionally offered in local dev.
 * Decided at build time — `auth.providers` config is not visible to the
 * browser, so it cannot be read at runtime here.
 */
const providers: (SignInProviderConfig | 'guest')[] =
  process.env.NODE_ENV === 'development'
    ? ['guest', githubProvider]
    : [githubProvider];

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const Component = (props: SignInPageProps) => (
        <SignInPage {...props} providers={providers} />
      );
      return Component;
    },
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
